import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { Role } from '@mdu-invoicing/shared';
import { useAuth } from '@/hooks/useAuth';

/**
 * Renders its children only for users whose role is allowed; otherwise redirects
 * to the dashboard. Defense-in-depth for STAFF-only screens (the nav already hides
 * them and the API enforces authorization) — it stops a PROVIDER from reaching a
 * staff screen by typing the URL directly. Assumes it sits inside ProtectedRoute,
 * so the user is already authenticated.
 */
export function RoleGuard({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
